import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import 'chart.js'
import {BarChart} from 'react-chartkick'

export default class ScoresChart extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.date = null;
		this.state.books = [];
		this.state.calls = [];
		this.state.avgs = [];
	}

	render() {
		const {loading} = this.state;
		const {data} = this.props;
		if (data && data.length > 0) {
			if (this.state.date !== data[0]?.Date) {
				this.setState({date: data[0].Date})
				let books = [];
				let calls = [];
				let avgs = [];

				data.map((item) => {
					books.push([item.DisplayName, item.Books])
					calls.push([item.DisplayName, item.PhoneTotals])
					avgs.push([item.DisplayName, item.AvgTimeBetweenPhones])
				})

				this.setState({books, calls, avgs})
			}
		}

		return (
			<div className={'box-body'}>
				<Card>
					<CardContent>

						<div className={'row'}>
							<div className={'col-4 d-flex justify-content-center'}>
								{this.state.books.length > 0 ? <BarChart data={this.state.books} label={'Books'} dataset={{backgroundColor: 'blue'}} /> : <b> There is no data for the books chart. </b>}
							</div>

							<div className={'col-4 d-flex justify-content-center'}>
								{this.state.calls.length > 0 ? <BarChart data={this.state.calls} label={'Calls'} dataset={{backgroundColor: 'green'}} /> : <b> There is no data for the calls chart. </b>}
							</div>

							<div className={'col-4 d-flex justify-content-center'}>
								{this.state.avgs.length > 0 ? <BarChart data={this.state.avgs} label={'Avg Time'} dataset={{backgroundColor: 'red'}} /> : <b> There is no data for the avgs chart. </b>}
							</div>
						</div>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
